import i18n from '../../src/i18n/i18n';
import moment from 'moment';

let instance = i18n().getInstance();
instance.loadTranslations = () => {
  if(window.hasOwnProperty('translations') && Object.keys(window.translations).length !== 0) {
    Object.values(window.translations).forEach(translation => {
      Object.keys(translation).forEach(language => {
        instance.addResourceBundle(language, 'defaultNamespace', translation[language]);
      });
    });
  }

  moment.locale(instance.language);
}
if (typeof window !== 'undefined') {
  instance.loadTranslations();
}
export default instance;
